import actions from './actions';

const initState = {
  isEditorImageUploading: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.UPLOAD_TEXT_EDITOR_IMAGE: {
      return {
        ...state,
        isEditorImageUploading: action.payload,
      };
    }
    default:
      return state;
  }
};
